import { useCallback, useContext } from 'react';

import { type AirActionTrackingLocation, useTrackClickedFileUpload } from '@air/analytics';

import { UploadContext } from '~/components/PrivateDropzone/components/UploadDropzone';
import { useActiveSubscriptionCallback } from '~/swr-hooks/subscriptions/useActiveSubscriptionCallback';

export const useUploadFilesFromComputer = ({ trackLocation }: { trackLocation: AirActionTrackingLocation }) => {
  const { openUploader } = useContext(UploadContext);
  const { activeSubscriptionCallback } = useActiveSubscriptionCallback();
  const { trackClickedFileUpload } = useTrackClickedFileUpload();

  const uploadFilesFromComputer = useCallback(
    () =>
      activeSubscriptionCallback(() => {
        openUploader();
        trackClickedFileUpload({ location: trackLocation });
      }),
    [activeSubscriptionCallback, openUploader, trackLocation, trackClickedFileUpload],
  );

  return {
    uploadFilesFromComputer,
  };
};
